import Floor from "./Floor"
import Cockpit from "./Cockpit"


export default function ActeOneModels({id}) {
    return (
        <>
            <Floor />
            <Cockpit id={id} />
        </>
    )
}